export default __webpack_public_path__ + "static/media/fail_cross.b6487b53.svg";